import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScaleupButtonDirective } from './scaleup-button.directive';

@NgModule({
  declarations: [
    ScaleupButtonDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ScaleupButtonDirective
  ],
})
export class ScaleupButtonModule { }
